<template lang="pug">
.section
  .field
    .control
      .select.is-fullwidth.is-primary
        select(v-model="component")
          option(v-for="component in components" v-bind:value="component.value") {{ component.label }}
  component(v-bind:is="component")
</template>

<script>
import SightReductionNP303 from '@/components/SightReductionNP303.vue'

import ServiceWorkerMixin from '@/mixins/ServiceWorkerMixin.vue'

export default {
  components: {
    SightReductionNP303
  },
  mixins: [
    ServiceWorkerMixin
  ],
  data () {
    return {
      component: 'SightReductionNP303',
      components: [
        {
          label: 'Sight Reduction NP303',
          value: 'SightReductionNP303'
        }
      ]
    }
  }
}
</script>

<style lang="sass">
@import '~@fortawesome/fontawesome-free/css/all.min.css'
@import "~bulma/sass/utilities/_all"

$input-disabled-color: $grey-dark
$input-disabled-background-color: $white-ter
$input-disabled-border-color: $grey-dark

@import "~bulma"
@import "~buefy/src/scss/buefy"

.container.is-fluid
  padding-left: 8px
  padding-right: 8px

.has-addons .control
  input.addon, select
    width: 70px

.input[disabled]
  z-index: -1

.panel
  box-shadow: none

.panel-block
  border: $panel-item-border
  &:last-of-type
    border-radius: 0
    border-top-style: none

.section
  padding: 12px
</style>
